import useFileSaver from '@hooks/useFileSaver';
import useRequest, { IDataRequest } from '@hooks/useRequest';
import { IContratoCliente } from '@model/ContratoCliente';
import { EnumContratoClienteStatus } from '@model/ContratoClienteStatus';
import { EnumEmpresa } from '@model/Empresa';
import { EnumOperadora } from '@model/Operadora';
import React from 'react';

export interface IRelatorioValorFranquiaPlanosFilter {
    empresaId?: EnumEmpresa
    operadoraId?: EnumOperadora
    valorPlanoDe?: number
    valorPlanoAte?: number
    franquiaGbDe?: number
    franquiaGbAte?: number
    contratoClienteStatusId?: EnumContratoClienteStatus
}

export interface IRelatorioValorFranquiaPlanosRecord extends IContratoCliente {
    quantidade: number
}

const controller = '/Relatorio/ValorFranquiaPlanos';

export function useRelatorioValorFranquiaPlanosService () {
    const _request = useRequest();
    const fileSaver = useFileSaver();

    const listar = React.useCallback((request: IDataRequest<IRelatorioValorFranquiaPlanosFilter>) => {
        return _request.getData<IRelatorioValorFranquiaPlanosRecord[]>(`${controller}/Listar`, request);
    }, [_request]);

    const exportar = React.useCallback((request: IDataRequest<IRelatorioValorFranquiaPlanosFilter>) => {
        return _request.download(`${controller}/Exportar`, {
            params: request
        })
            .then(response => { 
                fileSaver.save(response, `Valores-Franquia-Planos.csv`);
            });
    }, [_request, fileSaver]);

    return React.useMemo(() => ({
        listar, exportar
    }), [listar, exportar]);
}